import React, { useState } from 'react';
import { Button, Form, Input, Modal, Space } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { deleteCustomer, exportToCSV, getB2BUsers, getUsersList } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import Can from '../../permission/Can';

const B2BUsersList = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [exportData, setExportData] = useState([])
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [reload, setReload] = useState(false)
    const columns = [
        {
            title: 'First Name',
            dataIndex: 'first_name',
            key: 'first_name',
        },
        {
            title: 'Last Name',
            dataIndex: 'last_name',
            key: 'last_name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Code',
            dataIndex: 'code_id',
            key: 'code_id',
            render : (_, data) => {
                return data?.code_id?.code || "N/A"
            }
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render : (_, data) => {
                if (data?.createdAt) {
                    const date = new Date(data?.createdAt);
                    return date.toLocaleDateString('en-CA')
                }
            }
        },
        {
            title: 'Block/UnBlock',
            dataIndex: 'is_verified',
            key: 'is_verified',
            render: (_, data) => {
                if (data?.is_verified == 1) {
                    return 'UnBlock'
                } else if (data?.is_verified == 0) {
                    return 'Block'
                }
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Can permission="edit_customer">
                        <Button onClick={() => navigate('/customer/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                    </Can>
                    <Button onClick={() => navigate('/customer/view/' + data?._id)} icon={<EyeOutlined />} size="small">View</Button>
                    <Can permission="delete_customer">
                        <Button onClick={() => openCustomerModal(data?._id)} icon={<DeleteOutlined />} size="small" danger>Delete</Button>
                    </Can>
                </Space>
            ),
        },
    ];

    const openCustomerModal = async (id) => {
        setSelectedId(id);
        setOpenModal(true);
    };

    const searchedData = async (data) => {
        setExportData(data)
    }

    const handleDeleteCustomer = async (values) => {
        setLoading(true);
        try {
            let data = {
                userId : selectedId,
                reason : values?.reason
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
            const resultAction = await dispatch(deleteCustomer(data))
            if (deleteCustomer.fulfilled.match(resultAction)) {
                setReload(!reload)
                setOpenModal(false);
                setLoading(false);
                form.resetFields()
            }
        } catch (error) {
            setLoading(false);
            setOpenModal(false);
        } finally {
            setLoading(false);
            setOpenModal(false);
        }
    }

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>B2B Users</h1>
            </div>
            <TableComponent
                listData={getB2BUsers}
                roleType="business_user"
                selectPlaceHolder="Select B2B User"
                columns={columns}
                reload={reload}
                searchedData={searchedData}
                placeholder="Search customers..."
                listName="User"
            />
            <Modal
                title="Delete Confirmation"
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={null}
            >
                <p>Are you sure you want to delete this?</p>
                <Form
                    layout="vertical"
                    onFinish={handleDeleteCustomer}
                    form={form}
                >
                    <Form.Item
                        label="Reason"
                        name="reason"
                        rules={[{ required: true, message: 'Please input reason!' }]}
                    >
                        <Input placeholder="Enter reason" />
                    </Form.Item>
                    <Form.Item>
                    <Button htmlType='submit' loading={loading} icon={<DeleteOutlined />} size="small" danger>Yes</Button>
                    </Form.Item>
                </Form>
                <Space>
                    <Button onClick={() => setOpenModal(false)} size="small" primary>No</Button>
                </Space>
            </Modal>
        </div>
    );
};

export default B2BUsersList;

